import React from 'react'
import { Grid, Chip } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import useStyles from './styles'

const Filter = ({ options, setOption, selected, disabled, fullWidth }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const handleChange = (e) => {
    setOption(e.currentTarget.id)
  }

  return (
    <Grid container spacing={2}>
      {Object.entries(options).map(([key, label]) => (
        <Grid item key={`filter-${key}`} xs={fullWidth}>
          <Chip
            key={key}
            variant="outlined"
            size="medium"
            label={t(label)}
            onClick={handleChange}
            disabled={disabled || selected === key}
            className={disabled && selected !== key ? classes.unselectable : ''}
            classes={{
              root: classes.root,
              ...(disabled && selected !== key ? {} : { disabled: classes.disabled }),
            }}
            id={key}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default Filter